import React from 'react';
import { ContentSidebar } from '@components/content-side-bar/ContentSidebar';
import { Advertisement } from '@components/content-side-bar/Advertisement';
import { PopularCompetitions } from '@components/content-side-bar/PopularCompetitions';
import { ActivityFeed } from '@components/feed/ActivityFeed';
import { PortalPageLayout } from '@layouts/PortalPageLayout';
import { useTranslation } from 'react-i18next';

export const Feed: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  const sidebar = (
    <ContentSidebar>
      <PopularCompetitions />
      <Advertisement />
    </ContentSidebar>
  );

  return (
    <PortalPageLayout
      title={t('competitions:portal.feed.title')}
      subTitle={t('competitions:portal.feed.subTitle')}
      sidebarContent={sidebar}
      wrapContentInPanel={false}
      hidePageTitle
    >
      <ActivityFeed scope="competitions" />
    </PortalPageLayout>
  );
};
